// CONSTANTS are all caps.
const NS = 'SiteNav';
const CLS = 'siteNav';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/siteNav.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

import * as utils from '../../../../global/js/utils';

export class SiteNav {
	constructor($el) {
		// $el is the widget node return by the loadSiteNav function
		this.$el = $el;
	}

	init() {
		this.setSiteNav();
	}

	setSiteNav() {
		// Add Some logic here
		if (!utils.isOnMobile()) {
			this.toggleSiteNavItemsOnHover();
		}
	}

	toggleSiteNavItemsOnHover() {
		let navItem = $('.siteNav .nav-item');

		navItem.hover(
			function() {
				$(this).addClass('show');
				$(this).find('.dropdown-menu').addClass('show');
				$(this).find('.dropdown-toggle').attr('aria-expanded', 'true');
			},
			function() {
				$(this).removeClass('show');
				$(this).find('.dropdown-menu').removeClass('show');
				$(this).find('.dropdown-toggle').attr('aria-expanded', 'false');
			}
		);
	}

	// Add more functions like on above here
}



// WEBPACK FOOTER //
// C:/Users/GavinDow/source/repos/FrontEndWebsite/src/views/widgets/siteNav/js/siteNav.js